module.exports = __webpack_public_path__ + "static/media/MorristownMedical.f1d6a943.png";